import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AuthProvider } from './context/AuthContext';
import { theme } from './styles/theme';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import PlansPage from './pages/PlansPage';
import DashboardPage from './pages/DashboardPage';
import CreateEventPage from './pages/CreateEventPage';
import AdminEventPage from './pages/AdminEventPage';
import GuestEventPage from './pages/GuestEventPage';
import PaymentPage from './pages/PaymentPage';
import BankTransferPage from './pages/BankTransferPage';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter basename="/app">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/planes" element={<PlansPage />} />
            <Route
              path="/dashboard"
              element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
            />
            <Route
              path="/dashboard/nuevo-evento"
              element={<ProtectedRoute><CreateEventPage /></ProtectedRoute>}
            />
            <Route
              path="/dashboard/evento/:eventId"
              element={<ProtectedRoute><AdminEventPage /></ProtectedRoute>}
            />
            <Route path="/event/:eventCode" element={<GuestEventPage />} />
            <Route
              path="/dashboard/pagar"
              element={<ProtectedRoute><PaymentPage /></ProtectedRoute>}
            />
            <Route path="/transferencia" element={<BankTransferPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
